import $ from 'jquery';
import globalConfigVariables from './configs.js';

function onSuccess(googleUser) {
    console.log(googleUser);
    console.log('Login ID: ' + googleUser.getBasicProfile().getId());
    console.log('Logged in as: ' + googleUser.getBasicProfile().getName());
    console.log('Email: ' + googleUser.getBasicProfile().getEmail());
    var id_token = googleUser.getAuthResponse().id_token;
    console.log(id_token);

    var getTokenAPI = globalConfigVariables.apiDomain + "staff/auth?tokenId=" + id_token;

    $.ajax({
        method: 'GET',
        url: getTokenAPI,
    })
        .done(function(data) {
            localStorage.setItem('getName', googleUser.getBasicProfile().getName());
            localStorage.setItem('tokenId', googleUser.getAuthResponse().id_token);
            window.location.replace('/timesheet.html', googleUser.getAuthResponse().id_token);
        })
        .fail(function(jqXHR, errorThrown, textStatus) {
            alert('You are using the wrong email!');
            console.log(jqXHR);
        });
}

function onFailure(error) {
    console.log(error);
    alert('This is an unauthorised access:');
}

function renderButton() {
    gapi.signin2.render('go-signin', {
        scope: 'profile email',
        width: 240,
        height: 50,
        longtitle: true,
        theme: 'dark',
        onsuccess: onSuccess,
        onfailure: onFailure,
    });
}

function signOut() {
    $('#gSignOut').on('click', function(e) {
        e.preventDefault();
        console.log('Click');
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function() {
            localStorage.removeItem('getName');
            console.log('User signed out.');
            window.location.replace('/index.html');
        });
    });
}

function init() {

    gapi.load('auth2', function() {
        gapi.auth2.init();
    });

    signOut();

}

export default {
    init, renderButton, onFailure, onSuccess
}